import { DispatchOrder } from "../dispatch-order/dispatch-order";
import { TrackingState } from "../trackingstate/trackingstate";
import { User } from "../user/user";

export class TrackingCreate
{
    id : number; 
    shipper : String; 
    trackingnumber : String; 
    date : Date; 
    user : number; 
    dispatchorder : number; 
    trackingstate : number; 
}
export class Tracking
{
    id:number;
    shipper : String; 
    trackingnumber : String; 
    date : Date; 
    user : User;
    dispatchorder : DispatchOrder;
    trackingstate : TrackingState;
}
